import { api } from '@goaltree/backend/convex/_generated/api'
import { cn } from '@goaltree/ui/lib/utils'
import { Link } from '@tanstack/react-router'
import { useQuery } from 'convex/react'
import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { GroveIcon } from '@/components/groves/grove-icon'
import { StreakFlame } from '@/components/streak-icons'

// Slim Today line per grove: how many members have checked in, so the shared
// streak nudges you before you're the one who breaks it.
export function GroveToday({ className }: { className?: string }) {
  const { t } = useTranslation()
  const groves = useQuery(api.groves.todayStatus)
  if (!groves?.length) return null
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {groves.slice(0, 2).map((g) => {
        const allIn = g.checkedIn >= g.memberCount
        return (
          <Link
            key={g.groveId}
            to="/groves/$groveId"
            params={{ groveId: g.groveId }}
            className="flex items-center gap-2.5 rounded-xl border border-border/60 bg-card/50 px-3 py-2 transition-colors hover:bg-muted/50"
          >
            <GroveIcon icon={g.icon} size="xs" />
            <span className="min-w-0 flex-1 truncate text-[13px]">
              <span className="font-semibold">{g.name}</span>
              <span className="text-muted-foreground">
                {' · '}
                {allIn
                  ? t('groves.today.allIn')
                  : !g.iCheckedIn
                    ? t('groves.today.waitingOnYou', {
                        done: g.checkedIn,
                        total: g.memberCount,
                      })
                    : t('groves.today.checkedIn', { done: g.checkedIn, total: g.memberCount })}
              </span>
            </span>
            {g.groveStreak > 0 && (
              <span className="shrink-0 font-mono text-[11px] font-bold">
                <StreakFlame /> {g.groveStreak}
              </span>
            )}
            {g.unread > 0 && (
              <span className="flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground">
                {g.unread}
              </span>
            )}
            <ChevronRight className="size-3.5 shrink-0 text-muted-foreground" />
          </Link>
        )
      })}
    </div>
  )
}
